<template>
  <svg class="IconClipboardText" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
</svg>
</template>
<script>
  export default {
    name: 'IconClipboardText',
  }
</script>

<style lang="scss" >
  @import "../../../assets/scss/variable";
  .IconClipboardText{
    width: 90px;
    height: 40px;
    margin-bottom: 2px;
    color: var(--projectPrimaryColor);
    fill: currentColor;
  }
</style>